/**
 * Acces reactif aux donnees depuis l'interface.
 *
 * Un seul `useLiveQuery` charge l'instantane complet ; chaque ecriture Dexie le
 * rafraichit, et l'index derive se recalcule. Pour un budget personnel, c'est
 * plus simple et plus sur que des requetes par ecran : il n'existe qu'une
 * version des donnees a un instant donne, et tous les ecrans la partagent.
 */

import { useLiveQuery } from 'dexie-react-hooks'
import { createContext, useContext, useMemo, type ReactNode } from 'react'

import { indexer, type Donnees, type Index } from '../analysis/donnees'
import { chargerDonnees, lireReglages } from '../db/repo'
import { REGLAGES_DEFAUT, type Reglages } from '../domain/types'

export interface Contexte {
  d: Donnees
  ix: Index
  reglages: Reglages
}

const Ctx = createContext<Contexte | null>(null)

export function FournisseurDonnees({ children }: { children: ReactNode }) {
  const d = useLiveQuery(chargerDonnees, [])
  const reglages = useLiveQuery(lireReglages, []) ?? REGLAGES_DEFAUT
  const valeur = useMemo(() => (d ? { d, ix: indexer(d), reglages } : null), [d, reglages])

  if (!valeur) {
    return <div className="vide">Chargement…</div>
  }
  return <Ctx.Provider value={valeur}>{children}</Ctx.Provider>
}

export function useDonnees(): Contexte {
  const v = useContext(Ctx)
  if (!v) throw new Error('useDonnees hors du FournisseurDonnees')
  return v
}
